import type { LinkedWorkRef } from '../types/surveillanceRoute';
import { OrderType } from '../types/orders';
import { buildActionSummaryPath } from './surveillanceRoute';

/**
 * Ruta a la que lleva un trabajo del aviso. Actuación → su resumen dentro del
 * recorrido; accidente → su detalle (bajo la campaña si la OT del aviso lo es).
 * `null` si falta el id de la entidad.
 */
export function buildLinkedWorkPath(
  work: LinkedWorkRef,
  ctx: { routeId?: string | null; otId?: string | null; otType?: string | null }
): string | null {
  if (work.type === 'accident') {
    if (!work.accidentId) return null;
    return ctx.otType === OrderType.Campaign && ctx.otId
      ? `/work-orders/campaign/${ctx.otId}/accidents/detail/${work.accidentId}`
      : `/work-orders/accidents/detail/${work.accidentId}`;
  }
  if (work.type === 'action') {
    return work.actionId
      ? buildActionSummaryPath(work.actionId, ctx.routeId)
      : null;
  }
  return null;
}
